import { AxiosInstance } from "axios";
import { Messages } from "../constants/Messages";

export const setupAPIResponseInterceptor = (apiInstance: AxiosInstance) => {
    apiInstance.interceptors.response.use(
        (response) => response, // Return the response as is if successful
        (error) => {
            if (error.response) {
                const { status } = error.response;

                switch (status) {
                    case 401: // Handle 401 Unauthorized
                        console.error(Messages.ERROR_AUTHORIZATION);
                        window.location.href = "/login"; // Redirect to login page
                        return Promise.reject(new Error(Messages.ERROR_AUTHORIZATION));

                    case 403: // Handle 403 Forbidden
                        console.error(Messages.ERROR_FORBIDDEN);
                        window.location.href = "/login"; // Redirect to login page
                        return Promise.reject(new Error(Messages.ERROR_FORBIDDEN));

                    default:
                        // Handle other error statuses if needed
                        break;
                }
            }

            return Promise.reject(error); // Return the original error if not handled above
        },
    );
};

export const setupAPIRequestInterceptor = (apiInstance: AxiosInstance) => {
    apiInstance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("token");
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error), // Forward any request errors
    );
};